import { PayloadAction } from '@reduxjs/toolkit';
import { all, call, fork, select, put, takeEvery, delay } from 'redux-saga/effects';
import { IViewer, loadingState, updateViewerState, ViewerState } from 'core/slices/player';
import { EntityTypes } from 'constants/entities';
import { updateState } from 'core/actions/product/state';
import { selectFeedNext } from 'core/selectors/product/action/actionNext';
import { selectSessionMode } from 'core/selectors/admin/sessionMode';
import { Mode } from 'core/slices/session';
import { RootState } from 'types';
import { IActionFeedItem } from 'core/selectors/product/action/actionFeed';
import { selectAction } from 'core/selectors/product/action/action';
import { IActionBasic } from 'types/domain/action';
import { IRegisterAction, registerAction } from 'core/slices/register';
import { selectActionCurrent } from 'core/selectors/product/action/actionCurrent';
import { LoadingState } from 'types/domain/base';

function* viewerStateSaga(action: PayloadAction<IViewer>) {
  //const prodEnts = yield select((state: RootState) => state.entity.present);
  if (action.payload.state === ViewerState.RESTING) {
    yield delay(100);
    yield loadNextScene();
  }
}

function* registerActionSaga(action: PayloadAction<Partial<IRegisterAction>>) {
  //const prodEnts = yield select((state: RootState) => state.entity.present);

  if (action.payload.result) return;

  // yield loadNextScene();
}

function* loadNextScene(time = 1000) {
  const mode: Mode = yield select(selectSessionMode);
  const action: IActionBasic = yield select(selectActionCurrent);
  const sceneId = yield select((state: RootState) => state.state[EntityTypes.SCENE]);
  const nextItem: IActionFeedItem = yield select(selectFeedNext);

  const nextAction: IActionBasic = yield select((state: RootState) =>
    nextItem?.actionId ? selectAction(state, nextItem?.actionId) : null,
  );

  if (!action?.sceneId && nextAction && nextAction.sceneId && mode !== Mode.ADMIN && nextAction.sceneId !== sceneId) {
    yield put(yield call(loadingState, { scene: LoadingState.LOADING }));
    yield put(yield call(updateState, { type: EntityTypes.SCENE, id: nextAction.sceneId }));
  }
}

function* watchRegisterAction() {
  yield takeEvery(registerAction, registerActionSaga);
}

function* watchViewerStateAction() {
  yield takeEvery(updateViewerState.type, viewerStateSaga);
}

export function* nextSceneSaga() {
  yield all([fork(watchViewerStateAction), fork(watchRegisterAction)]);
}
